import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from 'Utils/inputUtils'

import {
  _OtherStats, _TitleValueBlock, _NoMarginRow,
} from './styles.js'

export const TEST_IDS = {
  TOGGLE_BTN: 'toggleBtn',
}

const OtherStats = ({ data }) => {
  const languages = data.data?.attributes?.mother_tongue?.variables
  const educationLevels = data.data?.attributes?.education_level?.variables
  const incomes = data.data?.attributes?.income?.variables
  return (
    <_OtherStats>
      <h4>Languages</h4>
      <_NoMarginRow>
        {
          languages && languages.map(language => {
            const percentage = Math.round(language.value * 100)
            if(percentage) {
              return (
                <_TitleValueBlock
                  title={`${language.label}:`}
                  value={`${percentage}%`}
                  key={language.variable}
                  flexContainer
                />
              )
            }
            return ''
          })
        }
      </_NoMarginRow>

      <h4>Education</h4>
      <_NoMarginRow>
        {
          educationLevels && educationLevels.map(level => {
            const percentage = Math.round(level.value * 100)
            if(percentage) {
              return (
                <_TitleValueBlock
                  title={
                    level.variable === 'no_high_school' ? 'No Diploma:' :
                      `${level.label}:`
                  }
                  value={`${percentage}%`}
                  key={level.variable}
                  flexContainer
                />
              )
            }
            return ''
          })
        }
      </_NoMarginRow>

      <h4>Average Income</h4>
      <_NoMarginRow>
        {
          incomes && incomes.map(income => {
            const percentage = income.value ? formatPrice(income.value.toFixed()) : ''
            if(percentage) {
              return (
                <_TitleValueBlock
                  title={
                    income.variable === 'avg_household_income' ?
                      'Household:' : 'Individual:'
                  }
                  value={`${percentage} /yr`}
                  key={income.variable}
                  flexContainer
                />
              )
            }
            return ''
          })
        }
      </_NoMarginRow>
    </_OtherStats>
  )
}


OtherStats.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        mother_tongue: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        education_level: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        income: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
      }),
    }),
  }),
}

export default OtherStats
